import React from "react";
import { I18n } from "@aws-amplify/core";
import update from "immutability-helper";
import { get, map, includes, toLower } from "lodash";
import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import DatePicker from "../../Common/DatePicker";
import FormSection from "../../Common/FormSection";
import { formatDate, formatTimeSlot } from "../../../utils/date";
import RecurrenceDialog from "./RecurrenceDialog";
import images from "../../../assets/img/images";
import { getRecurrenceSentence } from "../../../utils/scheduler";

const repeatPatterns = [
  {
    code: "noRepeat",
    name: "scheduler_doesNotRepeat",
  },
  {
    code: "daily",
    name: "scheduler_repeatDaily",
  },
  {
    code: "weekly",
    name: "scheduler_repeatWeekly",
  },
  {
    code: "monthly",
    name: "scheduler_repeatMonthly",
  },
  {
    code: "yearly",
    name: "scheduler_repeatYearly",
  },
];

const AddOccurrenceDateForm = (props) => {
  const { classes, formValues, handleChange, timeSlots, edition, recurrenceLine } = props;
  const [openCustom, setOpenCustom] = React.useState(false);
  const [checkOpenCustom, setCheckOpenCustom] = React.useState(false);

  React.useEffect(() => {
    if (
      includes(
        ["daily", "weekly", "monthly", "yearly", "repeat"],
        get(formValues, ["recurrence", "repeat"])
      )
    ) {
      setOpenCustom(true);
    }
    setCheckOpenCustom(false);
    // eslint-disable-next-line
  }, [checkOpenCustom]);

  const formatDateLabel = (date) => {
    return `${formatDate(date, "DD/MM/YYYY")}`;
  };

  return (
    <Grid container direction="column" className={classes.container}>
      <Grid
        item
        container
        className={classes.containerTitle}
        style={{ height: 20, marginBottom: "16px" }}
      >
        <Grid item style={{ marginRight: "7px" }}>
          <img src={images.calendarIcon} height="16px" alt="calendar" />
        </Grid>
        <Grid item>{I18n.get("site_dateTime")}</Grid>
      </Grid>
      <Grid item>
        <DatePicker
          name="startDate"
          value={get(formValues, ["startDate"]) || new Date()}
          onChange={(name, date) => handleChange(name, null, date)}
          dateOnly
          formatLabel={formatDateLabel}
        />
      </Grid>
      <Grid item>
        <RadioGroup
          name="timeType"
          value={get(formValues, ["timeType"])}
          onChange={(e) => handleChange("timeType", null, e.target.value)}
        >
          <FormControlLabel
            value={"timeSlots"}
            control={
              <Radio color="primary" classes={{ root: classes.radioRoot }} />
            }
            label={I18n.get("scheduler_timeSlots")}
            labelPlacement="end"
            classes={{ label: classes.radio, root: classes.controlLabel }}
          />
          <FormControlLabel
            value={"custom"}
            control={
              <Radio color="primary" classes={{ root: classes.radioRoot }} />
            }
            label={I18n.get("dashboard_custom")}
            labelPlacement="end"
            classes={{ label: classes.radio, root: classes.controlLabel }}
          />
        </RadioGroup>
      </Grid>
      <Grid item style={{ marginTop: "16px" }}>
        {get(formValues, ["timeType"]) === "timeSlots" && (
          <FormSection
            formValue={[get(formValues, ["timeSlot"])]}
            setFormValue={handleChange}
            noLabel
            id={"timeSlot"}
            type="select"
            options={{
              noSort: true,
              options: map(timeSlots, (slot) => ({
                id: slot.id,
                name: formatTimeSlot(slot.start, slot.end),
              })),
            }}
          />
        )}
        {get(formValues, ["timeType"]) === "custom" && (
          <Grid container>
            <DatePicker
              label={I18n.get("common_from")}
              name="customStart"
              value={get(formValues, ["customStart"])}
              onChange={(id, value) => handleChange(id, null, value)}
              width={93}
              timeOnly
              style={{ marginRight: "24px" }}
            />
            <DatePicker
              label={I18n.get("common_to")}
              name="customEnd"
              value={get(formValues, ["customEnd"])}
              onChange={(id, value) => handleChange(id, null, value)}
              width={93}
              timeOnly
            />
          </Grid>
        )}
      </Grid>
      {!edition && (
        <FormSection
          formValue={[get(formValues, ["recurrence", "repeat"])]}
          setFormValue={(id, index, value) => {
            handleChange(
              "recurrence",
              index,
              update(get(formValues, ["recurrence"]), {
                repeat: { $set: value },
                every: { $set: 1 },
                on: {
                  $set:
                    value === "weekly"
                      ? [
                        toLower(
                          formatDate(get(formValues, ["startDate"]), "dddd")
                        ),
                      ]
                      : value === "monthly"
                        ? [
                          parseInt(
                            formatDate(get(formValues, ["startDate"]), "D")
                          ),
                        ]
                        : [],
                },
                ends: { $set: "on" },
                endsOn: { $set: new Date(get(formValues, ["startDate"])) },
              })
            );
          }}
          onClose={() => setCheckOpenCustom(true)}
          noLabel
          id={"repeatPattern"}
          type="select"
          options={{
            noSort: true,
            clickThrough: true,
            options: map(repeatPatterns, (pattern) => ({
              id: pattern.code,
              name: I18n.get(get(pattern, ["name"])),
            })),
          }}
        />
      )}
      {openCustom && (
        <RecurrenceDialog
          formValues={formValues}
          handleChange={handleChange}
          setOpen={setOpenCustom}
          repeatPatterns={repeatPatterns}
          onCancel={() =>
            handleChange("recurrence", null, {
              repeat: "noRepeat",
            })
          }
        />
      )}
      {edition
        ? ""
        : recurrenceLine(getRecurrenceSentence(formValues.recurrence.repeat, formValues))}
    </Grid>
  );
};

export default AddOccurrenceDateForm;
